var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNearbyLocationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.831 9.57561C17.1211 6.42049 14.3966 5 12.0034 5C12.0034 5 12.0034 5 11.9966 5C9.61013 5 6.87886 6.41366 6.169 9.56878C5.37801 13.0927 7.51436 16.0771 9.44788 17.9551C10.1645 18.6517 11.0839 19 12.0034 19C12.9228 19 13.8423 18.6517 14.5521 17.9551C16.4856 16.0771 18.622 13.0995 17.831 9.57561ZM12.0034 12.9971C10.827 12.9971 9.8738 12.0341 9.8738 10.8459C9.8738 9.65756 10.827 8.69463 12.0034 8.69463C13.1797 8.69463 14.133 9.65756 14.133 10.8459C14.133 12.0341 13.1797 12.9971 12.0034 12.9971Z",
    fill: "#25245B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNearbyLocationIcon);
export default __webpack_public_path__ + "static/media/nearby-location-icon.2dc7d9f05965f33c75bb9f2c89a6003c.svg";
export { ForwardRef as ReactComponent };